import { Icon } from "@circle-react-shared/Icon";

export const CheckIcon = () => (
  <div className="mr-2">
    <Icon
      type="check"
      size={16}
      useWithFillCurrentColor
      useWithStrokeCurrentColor
      className="text-green-success"
    />
  </div>
);
